// src/LoginPage.js
import React, { useState } from "react";
import "./pages/LoginPage.css";
import logo from "./logo.png";


//const API_BASE =
  //window.location.hostname.includes("apphaker.com")
    //? "http://195.87.235.112:7260"
    //: "http://192.168.2.230:7260";

const API_BASE = "https://api.apphaker.com";



function LoginPage({ onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);
  setLoading(true);

  try {
    const res = await fetch(`${API_BASE}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        kullanici_adi: username, // ÖNEMLİ: modeldeki isimle aynı
        sifre: password,
      }),
    });

    if (!res.ok) {
      if (res.status === 401) {
        setError("Kullanıcı adı veya şifre hatalı!");
      } else {
        setError("Giriş sırasında bir hata oluştu.");
      }
      setLoading(false);
      return;
    }

    const data = await res.json();

    // { token, fullName, departman, kullanici_adi, yetki } gibi bir şey bekliyoruz
    if (!data || !data.token) {
      setError("Sunucudan geçersiz yanıt alındı.");
      setLoading(false);
      return;
    }

    localStorage.setItem("user", JSON.stringify(data));
    localStorage.setItem("token", data.token);

    if (onLoginSuccess) {
      onLoginSuccess(data);
    }
  } catch (err) {
    console.error("Login hata:", err);
    setError("Giriş sırasında bir hata oluştu.");
  } finally {
    setLoading(false);
  }
};


  return (
  <div className="login-root">
    {/* CSS yüklenmiyor olsa bile bu kesin çalışır */}
    <style>{`
      .login-root{
        min-height:100vh;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:24px;
        background: radial-gradient(circle at top left,#000 0%,#090b0b 35%,#020202 100%);
        font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        color:#e5e7eb;
      }
      .login-card{
        width:460px;
        max-width:95vw;
        background:#ffffff;
        border:1px solid #e5e7eb;
        border-radius:16px;
        padding:28px 30px 30px;
        box-shadow:0 40px 120px rgba(0,0,0,.70);
      }
      .login-header{
        display:flex;
        flex-direction:column;
        align-items:center;
        gap:10px;
        margin-bottom:18px;
        text-align:center;
      }
      .login-logo{
        width:260px;
        max-width:82%;
        height:auto;
        object-fit:contain;
        margin-bottom:2px;
      }
      .login-title{
        margin:0;
        font-size:22px;
        font-weight:700;
        letter-spacing:.2px;
        color:#0f172a;
      }
      .login-subtitle{
        margin:0;
        margin-top:2px;
        font-size:13px;
        color:#475569;
      }
      .login-form{
        display:flex;
        flex-direction:column;
        gap:14px;
      }
      .login-label{
        font-size:13px;
        font-weight:600;
        color:#0f172a;
        display:flex;
        flex-direction:column;
        gap:6px;
      }
      .login-input{
        height:44px;
        border-radius:10px;
        border:1px solid #cbd5f5;
        padding:0 12px;
        font-size:14px;
        color:#0f172a;
        background:#fff;
      }
      .login-input:focus{
        outline:none;
        border-color:#0a1a44;
        box-shadow:0 0 0 3px rgba(10,26,68,.18);
      }
      .login-error{
        font-size:13px;
        color:#991b1b;
        background:#fee2e2;
        border:1px solid #fecaca;
        padding:10px 12px;
        border-radius:10px;
      }
      .login-button{
        margin-top:6px;
        height:46px;
        border:none;
        border-radius:12px;
        background:#0a1a44;
        color:#fff;
        font-size:14px;
        font-weight:700;
        cursor:pointer;
        transition: background .15s ease, transform .15s ease;
      }
      .login-button:hover{ background:#102a6a; }
      .login-button:active{ transform: translateY(1px); }
      .login-button:disabled{ opacity:.65; cursor:not-allowed; }
    `}</style>

    <div className="login-card">
      <div className="login-header">
        <img className="login-logo" src={logo} alt="Haker" />
        <h1 className="login-title">Dashboard</h1>
        <p className="login-subtitle">Yetkili kullanıcı girişi</p>
      </div>

      <form onSubmit={handleSubmit} className="login-form">
        <label className="login-label">
          Kullanıcı Adı
          <input
            type="text"
            className="login-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />
        </label>

        <label className="login-label">
          Şifre
          <input
            type="password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        {error && <div className="login-error">{error}</div>}

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>
    </div>
  </div>
);

}

export default LoginPage;
